import ScarcityController from './Controller/ScarcityController';
